import { TCMRunProcess, TCMRunProcessService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { FileData, ResultData } from "@nt-portal/common-sdk";

export interface TCMRunProcessOptions extends ControllerOptions<TCMRunProcess> {
    bidId?: string;
    status?: string[];
    startDate?: Date;
    endDate?: Date;
}

export const initTCMRunProcess = () => {
    let item: TCMRunProcess = {
        userId: "",
        status: "",
        records: 0,
        fileName: "",
        fileSize: 0,
        createdBy: "",
        actionOptions: [],
        actions: []
    }
    return item;
}


export class ClientTCMRunProcessService extends BaseClientService implements DataController<TCMRunProcess> {

    private _service: TCMRunProcessService;


    constructor() {
        super();
        this._service = new TCMRunProcessService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }


    public async get(options: TCMRunProcessOptions): Promise<ResultData<TCMRunProcess>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.status?.join(","));

    }
    public async getLookup(options: TCMRunProcessOptions): Promise<ResultData<TCMRunProcess>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMRunProcessOptions): Promise<TCMRunProcess | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }

    public async delete(options: TCMRunProcessOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }

    public async file(options: TCMRunProcessOptions): Promise<FileData | null> {
        if (options.id) {
            let item = await this._service.file(this.token, options.id);
            return item;
        }
        return null;
    }
}